var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bullet point icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70105 1.91226C7.15042 1.5831 6.55427 1.47385 5.91281 1.58349L5.93318 6.50032L7.70105 1.91226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.95356 11.4172C5.32186 11.5289 4.72584 11.419 4.16532 11.0884L5.93318 6.50032L5.95356 11.4172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5213 8.27136C10.8505 7.72073 10.9597 7.12458 10.8501 6.48312L5.93327 6.50349L10.5213 8.27136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.34586 4.72864C1.01669 5.27927 0.907448 5.87542 1.01708 6.51688L5.93392 6.49651L1.34586 4.72864Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointIcon);
export default __webpack_public_path__ + "static/media/point-icon.52d8308371e2ff5b5e16546bae1deb48.svg";
export { ForwardRef as ReactComponent };